import { SVGProps } from "react"
const SvgLogoWillhaben = (props: SVGProps<SVGSVGElement>) => (
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 763.5 386.7" xmlSpace="preserve">
        <style type="text/css">
            {`.st0{fill:#FFFFFF;}
            .st1{fill:#00A4E8;}
            .st2{fill:#262274;}`}
        </style>
        <g>
            <path className="st0" d="M635.2,30.2H128.6c-54.4,0-98.3,44.7-98.3,100.1s43.9,100.1,98.3,100.1h506.3c54.4,0,98.3-44.7,98.3-100.1
                C733.2,75.2,689.3,30.2,635.2,30.2z"/>
                <path className="st1" d="M634.9,0H128.6C57.7,0,0,58.4,0,130.3s57.7,130.3,128.6,130.3h57.5l-35.6,54.7c-13.8,20.8-7.1,49.3,14.7,63.5
                c21.6,14.2,50.3,8.6,64-12.2l70.3-106h335.7c70.8,0,128.5-58.4,128.3-130.3C763.5,58.4,705.8,0,634.9,0z M634.9,200.5H128.6
                c-37.3,0-67.8-31.5-67.8-69.9c0-38.7,30.5-69.9,67.8-69.9h506.3c37.3,0,67.8,31.5,67.8,69.9C702.7,169.3,672.2,200.5,634.9,200.5z"
                />
                <path className="st2" d="M194.9,160.5h-20.6l-5.1-23.1c-1.1-5.2-1.9-10.5-2.3-15.8l0,0c-0.4,5.1-1.2,10.1-2.3,15l-5.3,23.9H140
                l-14.7-61.7h18l5.6,25.2c1,4.4,1.6,9,2,13.5l0,0c0.5-4.4,1.3-8.9,2.3-13.2l6.6-25.4h17l6.1,24.6c1.2,4.4,2,8.9,2.5,13.5l0,0
                c0.8-5.3,1.5-10.2,2.5-14.2l5.1-23.9h17L194.9,160.5z"/>
                <path className="st2" d="M220.6,160.5V98.8h17v61.7H220.6z"/>
                <path className="st2" d="M252.8,160.5V98.8h17v46.7h17v15.2h-34V160.5z"/>
                <path className="st2" d="M298.8,160.5V98.8h17v46.7h17v15.2h-34V160.5z"/>
                <path className="st2" d="M380.1,160.5v-24.4h-18.5v24.4h-17V98.8h17v22.6h18.5V98.8h17v61.7H380.1z"/>
                <path className="st2" d="M448.9,160.5l-3.3-10.2h-19.1l-3,10.2h-16.8l20.1-61.7h19.6l21.1,61.7H448.9z M439,129.5
                c-1-3.6-2.3-6.9-2.8-10.7h-0.3c-0.7,4-1.7,7.9-3,11.7l-2,6.9h10.7L439,129.5z"/>
                <path className="st2" d="M498.5,160.8c-3.8,0-10.9-0.3-21.3-0.3V99c6.1-0.3,17-0.5,24.6-0.5c13.5,0,21.8,5.1,21.8,16
                c-0.1,5.4-3.1,10.4-7.9,13v0.3c5.3,1.8,8.9,7.4,8.9,13.5C524.6,151.9,516,160.8,498.5,160.8z M499,112.3c-1.6-0.1-3.2,0-4.8,0.3
                v10.2h3.6c5.3,0,7.9-2.3,7.9-5.8C505.6,113.8,503.1,112.3,499,112.3z M498.5,135.4h-4.3v11.2c1,0,3,0.3,4.3,0.3
                c4.6,0,7.6-2,7.6-5.8C506.4,137.9,503.8,135.4,498.5,135.4L498.5,135.4z"/>
                <path className="st2" d="M536.3,160.5V98.8h36.1v14.5h-19.1v8.6h18v14h-18v9.9h19.1v14.7H536.3z"/>
                <path className="st2" d="M619.2,160.5l-10.4-21.1c-2.3-4.6-4.3-9.2-6.1-14c0.3,3.6,0.5,5.8,0.5,9.7v25.2h-16.3V98.8h21.8l8.9,18.3
                c2.5,5.6,5.3,11.2,7.4,16c-0.5-4.2-0.8-8.5-0.8-12.7V98.8h16.3v61.7H619.2z"/>
        </g>
    </svg>
)
export default SvgLogoWillhaben